var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.list && _vm.list.length >= 2 ? _c('section', {
    directives: [{
      name: "preventAndroidScroll",
      rawName: "v-preventAndroidScroll"
    }, {
      name: "report",
      rawName: "v-report.module",
      value: {},
      expression: "{}",
      modifiers: {
        "module": true
      }
    }],
    class: {
      pdTop: !_vm.isAppTab
    },
    on: {
      "touchmove": function touchmove($event) {
        $event.preventDefault();
      }
    }
  }, [!_vm.isReady ? _c('div', {
    staticClass: "banner"
  }, [_c('div', {
    key: 0,
    staticClass: "item",
    staticStyle: {
      "margin": "0 auto"
    },
    attrs: {
      "data-url": _vm.list[0].tActType.sH5Url
    },
    on: {
      "click": function click($event) {
        return _vm.clickThisItem(0);
      }
    }
  }, [_c('v-image', {
    staticClass: "banner_img",
    attrs: {
      "src": _vm._f("removeHttp")(_vm.list[0].tPicList.mpList.pic_1080x404)
    }
  })], 1)]) : _c('div', {
    ref: "slider",
    staticClass: "banner"
  }, _vm._l(_vm.list, function (item, index) {
    return _c('div', {
      directives: [{
        name: "report",
        rawName: "v-report",
        value: _vm.reportData.焦点图海报(item, index),
        expression: "reportData.焦点图海报(item, index)"
      }],
      key: index,
      staticClass: "item",
      attrs: {
        "data-url": item.tActType.sH5Url
      },
      on: {
        "click": function click($event) {
          return _vm.clickThisItem(index);
        }
      }
    }, [_c('v-image', {
      staticClass: "banner_img",
      attrs: {
        "src": _vm._f("removeHttp")(item.tPicList.mpList.pic_1080x404),
        "data-index": index
      }
    })], 1);
  }), 0)]) : _vm._e();
};
var staticRenderFns = [];
export { render, staticRenderFns };